import React, {useState} from 'react';
import {Menu, X} from 'lucide-react';

const SiteHeader: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="text-center">
      <nav className="border-gray-200 bg-fred-purple-900/35">
        <div className="max-w-screen-2xl flex flex-wrap items-center justify-between mx-auto px-4 py-8">
          <a href="https://www.frednet.co.nz/" className="flex items-center space-x-4">
            <img src="/images/frednet-logo.png" className="h-16" alt="Frednet broadband new zealand"/>
            <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">FREDNET</span>
          </a>
          <button data-collapse-toggle="navbar-default" type="button"
                  className="flex md:hidden items-center p-2 justify-center text-white"
                  aria-controls="navbar-default" aria-expanded="false" onClick={toggleMobileMenu}>
            <Menu className="w-8 h-8" />
          </button>
          {isMobileMenuOpen && (
              <div
                  className="flex flex-col gap-y-4 fixed inset-0 bg-fred-purple-900 z-[999] justify-center items-center md:hidden"
                  id="navbar-default">
                <button data-collapse-toggle="navbar-default" type="button"
                        className="fixed top-0 right-0 inline-flex items-center p-2 m-4 justify-center text-white"
                        aria-controls="navbar-default" aria-expanded="false" onClick={closeMobileMenu}>
                  <X className="w-8 h-8" />
                </button>
                <a href="https://www.frednet.co.nz/" className="flex items-center space-x-4 mb-8">
                  <img src="/images/frednet-logo.png" className="h-16" alt="Frednet broadband new zealand"/>
                  <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">FREDNET</span>
                </a>
                <ul className="w-1/2 font-medium text-center text-white flex flex-col p-4 space-y-4 border border-gray-100 rounded-lg bg-transparent">
                  <li>
                    <a href="https://www.frednet.co.nz/" onClick={closeMobileMenu}
                       className="block py-2 px-3 text-white rounded">Home</a>
                  </li>
                  <li>
                    <a href="https://www.frednet.co.nz/about" onClick={closeMobileMenu}
                       className="block py-2 px-3 text-white rounded">About</a>
                  </li>
                  <li>
                    <a href="https://www.frednet.co.nz/plans-services" onClick={closeMobileMenu}
                       className="block py-2 px-3 text-white rounded">Services</a>
                  </li>
                  <li>
                    <a href="https://www.frednet.co.nz/faqs-1" onClick={closeMobileMenu}
                       className="block py-2 px-3 text-white rounded">FAQs</a>
                  </li>
                  <li>
                    <a href="https://www.frednet.co.nz/contact" onClick={closeMobileMenu}
                       className="block py-2 px-3 text-white rounded">Contact</a>
                  </li>
                </ul>
              </div>
          )}
          <div className="hidden w-full md:block md:w-auto" id="navbar-default">
            <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0">
              <li>
                <a href="https://www.frednet.co.nz/"
                   className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white md:dark:text-blue-500"
                   aria-current="page">Home</a>
              </li>
              <li>
                <a href="https://www.frednet.co.nz/about"
                   className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">About</a>
              </li>
              <li>
                <a href="https://www.frednet.co.nz/plans-services"
                   className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Services</a>
              </li>
              <li>
                <a href="https://www.frednet.co.nz/faqs-1"
                   className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">FAQs</a>
              </li>
              <li>
                <a href="https://www.frednet.co.nz/contact"
                   className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default SiteHeader;
